import { render } from "./AiAskTerm.vue?vue&type=template&id=cfd33ef0"
import script from "./AiAskTerm.vue?vue&type=script&lang=js"
export * from "./AiAskTerm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__